import React, { useEffect } from "react";
import Firebase from "../../firebase";
import { useHistory } from "react-router-dom";

export default function Logout() {
  let history = useHistory();
  useEffect(() => {
    Firebase.logout();
    history.push("/");
  }, []);
  return <div></div>;
}
